module.exports = __webpack_public_path__ + "img/open-in-new-tab.955ca457.png";